import { render, staticRenderFns } from "./oneRecordDialog.vue?vue&type=template&id=26237db2&scoped=true&"
import script from "./oneRecordDialog.vue?vue&type=script&lang=js&"
export * from "./oneRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./oneRecordDialog.vue?vue&type=style&index=0&id=26237db2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26237db2",
  null
  
)

export default component.exports